import { render, staticRenderFns } from "./houseEstateDetail.vue?vue&type=template&id=ebab003a&scoped=true&"
import script from "./houseEstateDetail.vue?vue&type=script&lang=js&"
export * from "./houseEstateDetail.vue?vue&type=script&lang=js&"
import style0 from "./houseEstateDetail.vue?vue&type=style&index=0&id=ebab003a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebab003a",
  null
  
)

export default component.exports